import CalculateService from './calculate.service';

export default {
  /* eslint-disable no-shadow */
  install(Vue) {
    /* eslint-disable no-multi-assign */
    Vue.prototype.$calculateService = Vue.calculateService = new CalculateService();
  },
};
